import { IApiErrorToastParams } from './types';

export const B2BInfoTooManyRequestsErrorText: string =
  'Пожалуйста, повторите попытку позже или свяжитесь с нами по номеру 8 800 700 41 13';

export const B2BInfoGeneralErrorText: string = 'Что-то пошло не так';

export const ApiGatewayUrls: string[] = [`api.lenta.com`, `gateway`];
export const ApiGatewayUrlsPostWithFile: string[] = [`requirement/file/parse`, `content/constructor/form`];

export const CachedAGMethods: Map<string, { cacheKey: string }> = new Map([
  [
    'api-gateway/v1/catalog/categories',
    {
      cacheKey: 'ssr_categories',
    },
  ],
]);

export const ApiErrorToastParams: Map<string, IApiErrorToastParams> = new Map<string, IApiErrorToastParams>([
  ['/orderAppend', { life: 10000 }],
]);

export enum CartApiMethods {
  CartFromOrderAdd = 'cartFromOrderAdd',
}

export const deliveryModeExceptionUrls: string[] = ['users/address/check'];

/** SSR FetchBackend limit (default 1 MiB). catalog/categories ~1.0–1.1 MiB uncompressed (NG2825). */
export const SSR_HTTP_FETCH_MAX_RESPONSE_BODY_SIZE: number = 2 * 1024 * 1024;
